module.exports = __webpack_public_path__ + "static/media/16.2cb45283.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/16.svg
// module id = 2807
// module chunks = 3